<img class="expanded-image" [src]="data.imageUrl" />
<button class="close-button fade-in" (click)="onCloseClick()">
	<mat-icon>clear</mat-icon>
</button>
